import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { "data-testid": "firstAlternate" }
const _hoisted_2 = { class: "text-danger mr-1" }
const _hoisted_3 = { class: "px-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_ctx.alternates.length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["d-flex mb-3", _ctx.containerClass]),
        "data-testid": "alternateSearchRoot"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('didYouMean')), 1),
          _cache[1] || (_cache[1] = _createTextVNode()),
          _createVNode(_component_router_link, {
            to: '/b?q=' + _ctx.firstAlternate,
            class: "underline-link-from-center"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.firstAlternate), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _cache[5] || (_cache[5] = _createTextVNode()),
        (_ctx.additionalAlternates.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["d-flex font-size-xs", _ctx.containerClass])
            }, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn btn-sm font-size-xs d-flex justify-content-between align-items-center", _ctx.buttonClass]),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleShowAdditionalAlternates && _ctx.toggleShowAdditionalAlternates(...args)))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "xmark",
                  class: "opacity-0"
                }),
                _cache[2] || (_cache[2] = _createTextVNode()),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('otherSearchSuggestions')), 1),
                _cache[3] || (_cache[3] = _createTextVNode()),
                _createVNode(_component_font_awesome_icon, {
                  icon: "xmark",
                  class: _normalizeClass(_ctx.xMarkClass)
                }, null, 8, ["class"])
              ], 2),
              _cache[4] || (_cache[4] = _createTextVNode()),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.additionalAlternatesClass),
                "data-testid": "additionalAlternates"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalAlternates, (alternate, alternateIndex) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    key: alternateIndex,
                    to: '/b?q=' + alternate,
                    class: "mr-3 underline-link-from-center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(alternate), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                }), 128))
              ], 2)
            ], 2))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}